import React from 'react';

const widthContentOnly = {
  width: '1px',
};

const ColGroup = () => (
  <colgroup>
    <col style={widthContentOnly} />
    <col style={widthContentOnly} />
    <col style={widthContentOnly} />
    <col style={{ width: '175px' }} />
    <col style={{ width: '175px' }} />
  </colgroup>
);

export default ColGroup;
